<div class="app-content-container">
  <div class="flex flex-col justify-center items-center h-full">
    <!-- /Logo Box -->
    <header class="login-header place-content-center">
      <a class="company-logo-container" target="_blank" href="https://www.lufthansagroup.com/de/home.html" rel="noopener">
        <img class="h-[2rem]" src="assets/logos/brand-logo.svg" alt="Media Lounge" />
      </a>

      <sp-mobile-navigation class="toggle-button-top-right">
        <sp-footer></sp-footer>
      </sp-mobile-navigation>
    </header>

    <div class="login-main max-w-screen-sm w-full">
      <!-- /Sign in Box -->
      <div *ngIf="signInEmail" class="flex flex-col h-full place-content-center">
        <form class="login-form" [formGroup]="signInGroup" (ngSubmit)="emailSignIn()">
          <div>
            <h2 class="text-3xl my-8 text-center uppercase" i18n>Log in</h2>
          </div>
          <!-- Email -->
          <div class="mb-4">
            <div class="w-full">
              <span class="field-label" i18n>E-mail address</span>
              <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                <input matInput name="email" autocomplete="email" type="text" placeholder="Login email address" i18n-placeholder formControlName="email" data-test-id="login-field-email" />
                <button *ngIf="signInGroup.controls['email'].value" mat-icon-button type="button" (click)="clearInput('email', 'signInGroup')" matSuffix class="cursor-pointer">
                  <mat-icon><span class="material-icons-outlined icon-color-outlined">backspace</span></mat-icon>
                </button>
                <mat-error *ngIf="signInGroup.controls['email'].errors?.['required']" i18n>E-mail address required</mat-error>
              </mat-form-field>
            </div>
          </div>
          <!-- Buttons-->
          <div class="mb-6 w-full">
            <div class="flex flex-col lg:flex-row gap-2 place-content-between">
              <div class="w-full flex flex-col items-center">
                <button mat-flat-button class="w-full button-primary" [disabled]="signInGroup.invalid || disableSignInBtn" type="submit" data-test-id="login-btn-sign-in" i18n>Log in</button>
                <!-- Loader -->
                <div class="w-auto h-full pl-2 flex flex-row place-content-between items-center" *ngIf="loading">
                  <mat-spinner [diameter]="30" color="warn"></mat-spinner>
                </div>
              </div>
            </div>
          </div>
          <!--Hint Message-->
          <div class="text-center mt-2 w-full">
            <p style="color: var(--headline-color)" i18n>Please reset your password for the first login.</p>
          </div>
          <!-- Sign up link -->
          <div class="flex flex-col justify-start items-center">
            <p>
              <span class="sign-up-message text-gray-600" i18n>Don't have an account?</span>
              &nbsp;
              <a (click)="redirectToSignUp()" class="sign-up-link" i18n>Sign up here</a>
            </p>
          </div>
        </form>
      </div>

      <!-- /Sign in with pwd Box -->
      <div *ngIf="loginWithPwd" class="flex flex-col h-full place-content-center">
        <form class="login-form" [formGroup]="signInPwdGroup" (ngSubmit)="signInPwd()" *ngIf="loginAvailable">
          <div>
            <h2 class="text-3xl my-8 text-center" i18n>Log in</h2>
          </div>
          <!-- Email -->
          <div class="mb-4">
            <div class="w-full">
              <span class="field-label" i18n>E-mail address</span>
              <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                <input matInput readonly type="text" placeholder="Login username" i18n-placeholder formControlName="login_email_username" />
                <button
                  *ngIf="signInPwdGroup.controls['login_email_username'].value"
                  mat-icon-button
                  type="button"
                  (click)="clearInput('login_email_username', 'signInPwdGroup')"
                  matSuffix
                  class="cursor-pointer"
                >
                  <mat-icon><span class="material-icons-outlined icon-color-outlined">backspace</span></mat-icon>
                </button>
                <mat-error *ngIf="signInPwdGroup.controls['login_email_username'].errors?.['required']" i18n>Email is required</mat-error>
              </mat-form-field>
            </div>
          </div>
          <!-- Password -->
          <div class="mb-4">
            <div class="w-full">
              <div class="flex flex-row place-content-between">
                <span class="field-label" i18n>Password</span>
                <a (click)="loginAvailable = !loginAvailable" class="forgot-pwd text-color" i18n>Forgot password?</a>
              </div>
              <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                <input
                  autofocus
                  matInput
                  type="password"
                  placeholder="Password"
                  formControlName="login_password"
                  i18n-placeholder
                  data-test-id="login-field-password"
                  aria-describedby="password-hint"
                />
                <button *ngIf="signInPwdGroup.controls['login_password'].value" mat-icon-button type="button" (click)="clearInput('login_password', 'signInPwdGroup')" matSuffix class="cursor-pointer">
                  <mat-icon><span class="material-icons-outlined icon-color-outlined">backspace</span></mat-icon>
                </button>
                <mat-error *ngIf="signInPwdGroup.controls['login_password'].errors?.['required']" i18n>Password is required</mat-error>
                <mat-error *ngIf="signInPwdGroup.controls['login_password'].hasError('minlength')" i18n>Password isn't long enough, minimum of 8 characters</mat-error>
              </mat-form-field>
            </div>
          </div>
          <!-- Buttons-->
          <div class="mb-6 w-full">
            <div class="w-full flex flex-col place-content-between items-center">
              <button [disabled]="loading" mat-flat-button class="flex-auto w-full button-primary" type="submit" data-test-id="login-btn-sign-in" i18n>Log in</button>
            </div>
          </div>
          <!--Hint Message-->
          <div class="text-center mt-2 w-full">
            <p id="password-hint" style="color: var(--headline-color)" i18n>Please reset your password for the first login.</p>
          </div>
          <!--Error Message-->
          <div class="text-center font-bold mt-2 w-full text-red" *ngIf="message">
            <h4>{{ message }}</h4>
          </div>
          <!-- Loader -->
          <div class="w-full flex justify-center items-center" *ngIf="loading">
            <mat-spinner [diameter]="30" color="warn"></mat-spinner>
          </div>
          <!-- Sign up link -->
          <div class="flex flex-col justify-start items-center">
            <p>
              <span class="sign-up-message text-gray-600" i18n>Don't have an account?</span>
              &nbsp;
              <a (click)="redirectToSignUp()" class="sign-up-link" i18n>Sign up here</a>
            </p>
          </div>
        </form>

        <!-- Forgot password email group -->
        <form class="login-form" [formGroup]="forgotPasswordGroup" (ngSubmit)="forgotPassword()" *ngIf="!loginAvailable">
          <div>
            @if (maxFailedLoginAttempts) {
              <h2 class="font-bold text-xl text-center mb-6" i18n>Account locked</h2>
              <p class="text-center" i18n>Account locked after 5 failed login attempts.</p>
              <p class="text-center mb-8" i18n>Please reset your password or notify your support.</p>
            } @else {
              <h2 class="text-3xl my-8 text-center" i18n>Forgot Password</h2>
            }
          </div>
          <!-- Email -->
          <div class="mb-4">
            <div class="w-full">
              <span class="field-label">E-mail address</span>
              <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                <input matInput type="text" placeholder="E-mail address" i18n-placeholder formControlName="email" />
                <button *ngIf="forgotPasswordGroup.controls['email'].value" mat-icon-button type="button" (click)="clearInput('email', 'forgotPasswordGroup')" matSuffix class="cursor-pointer">
                  <mat-icon><span class="material-icons-outlined icon-color-outlined">backspace</span></mat-icon>
                </button>
                <mat-error *ngIf="forgotPasswordGroup.controls['email'].errors?.['required']" i18n>Email is required</mat-error>
                <mat-error *ngIf="forgotPasswordGroup.controls['email'].hasError('email')" i18n>Invalid email address</mat-error>
              </mat-form-field>
            </div>
          </div>
          <!-- Buttons-->
          <div class="mb-6 w-full">
            <div class="flex flex-col lg:flex-row gap-2 place-content-between">
              <div class="flex flex-row items-center">
                <button mat-flat-button class="w-48 lg:w-auto button-secondary" [disabled]="forgotPasswordGroup.invalid || disableResetPwdBtn" type="submit" i18n>Reset Password</button>
                <!-- Loader -->
                <div class="w-auto h-full pl-2 flex flex-row place-content-between items-center" *ngIf="loading">
                  <mat-spinner [diameter]="30" color="warn"></mat-spinner>
                </div>
              </div>

              <button *ngIf="!maxFailedLoginAttempts" class="w-48 lg:w-auto button-secondary" mat-flat-button type="button" (click)="loginAvailable = !loginAvailable">
                <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
                <ng-container i18n> Back to login</ng-container>
              </button>
            </div>
          </div>
          <!--Error Message-->
          <div class="text-center font-bold mt-2 w-full text-[#F44336]" *ngIf="message && loginAvailable">
            <h4>{{ message }}</h4>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="app-footer-container">
  <div class="flex flex-col justify-end h-full mb-2">
    <lh-footer></lh-footer>
    <!-- /Footer -->
    <sp-footer></sp-footer>
  </div>
</div>
